import {
  Directive,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { DropdownDirective } from '@macs-frontend/web/features/ui-kit/directives/dropdown.directive';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: '[UIKitDropdownToggle]',
  exportAs: 'UIKitDropdownToggle',
})
export class DropdownToggleDirective {
  // @ts-expect-error
  @Input() isDropdownOpened: boolean;
  @Output() toggleDropdown: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('style.cursor')
  get pointer() {
    return 'pointer';
  }
  @HostBinding('attr.aria-expanded') 'dropdown.isOpen()': any;
  @HostListener('click')
  handleClick() {
    this.dropdown.toggle();
  }

  constructor(
    @Inject(forwardRef(() => DropdownDirective))
    public dropdown: any,
  ) {}
}
